import { ERPGIcon } from 'motw_core/UI/Icons/ERPGIcon';
import * as React from 'react';
import { Switch } from 'source/app/presentation/MainPanel/Dreams/DreamTools/Switch/Switch';
import { AddNewGoalLink } from 'source/app/presentation/MainPanel/Goals/MoreGoalTools/AddNewGoal/AddNewGoalLink';
import GoalsContainer from 'source/app/presentation/MainPanel/Goals/GoalsContainer';
import { EditEnergyRankOrder } from 'source/app/presentation/MainPanel/Goals/MoreGoalTools/EditEnergyRankOrder/EditEnergyRankOrder';
import ChevronPanel from 'source/app/presentation/Shared/ChevronPanel/ChevronPanel';
import { AddNewComboLink } from './AddNewCombo/AddNewComboLink';

export function MoreGoalTools({
	goalsContainer
}: {
	goalsContainer: GoalsContainer;
}) {
	return (
		<ChevronPanel
			id="moreGoalTools"
			label="Goal options"
			icon={ERPGIcon.acorn}
		>
			<AddNewGoalLink />
			<AddNewComboLink />
			<Switch
				label="Show hidden"
				onChange={() =>
					goalsContainer.setState({
						showHiddenGoals: !goalsContainer.state.showHiddenGoals
					})}
				isChecked={goalsContainer.state.showHiddenGoals}
			/>
			<Switch
				label="Show archived"
				onChange={() =>
					goalsContainer.setState({
						showArchivedGoals: !goalsContainer.state
							.showArchivedGoals
					})}
				isChecked={goalsContainer.state.showArchivedGoals}
			/>
			<EditEnergyRankOrder goalsContainer={goalsContainer} />
		</ChevronPanel>
	);
}

export interface IMoreGoalToolsState {
	showHiddenGoals: boolean;
	showArchivedGoals: boolean;
}
